import React from "react";

import "./electricity-biller.css";

import Searchinput from "app/components/search-input/Searchinput";

function ElectricityBillers() {
  return (
    <>
      <Searchinput title="Type Your Provider Name" />
      <div className="c-list mobile-operator">
        <div className="name-circle">
          <p></p>
        </div>
        <div className="name">
          <h3>adani Electricity Mumbai Limited</h3>
        </div>
      </div>
      <div className="c-list mobile-operator">
        <div className="name-circle">
          <p></p>
        </div>
        <div className="name">
          <h3>tata Power - Mumbai</h3>
        </div>
      </div>
      <div className="c-list mobile-operator">
        <div className="name-circle">
          <p></p>
        </div>
        <div className="name">
          <h3>best mumbai</h3>
        </div>
      </div>
      <div className="c-list mobile-operator">
        <div className="name-circle">
          <p></p>
        </div>
        <div className="name">
          <h3>msedc</h3>
        </div>
      </div>
      <div className="c-list mobile-operator">
        <div className="name-circle">
          <p></p>
        </div>
        <div className="name">
          <h3>torrent Power</h3>
        </div>
      </div>
    </>
  );
}

export default ElectricityBillers;
